(function () {
  'use strict';

  /* mr-product-gallery-enhance.js -- RC2 (2026-07-13), extended 2026-07-16.
     Additive-only Product Media Gallery behavior. Zero edits to any Dawn asset.

     2026-07-16 (Akkas) MOBILE VIDEO AUTOPLAY, v2. Product-media videos would
     not autoplay inline on mobile -- you had to tap the poster's play button,
     which then opened the fullscreen modal. Root cause: Dawn keeps each product
     video as a DEFERRED media (poster + play button, preload=none) wrapped in a
     modal-opener, so nothing mounts the <video> until a tap, and the tap hits
     the modal. Dawn's own <template> video already carries
     autoplay/muted/loop/playsinline -- it just is never mounted inline.
     Fix: on load, MOUNT that inline <video> into every gallery video slide
     (muted, looped, playsinline, no controls), so the browser autoplays
     whichever slide is on screen natively -- desktop AND mobile -- the same way
     the proof-gallery / story-card videos already do. We clone the template
     ourselves (NOT Dawn's loadContent, which calls window.pauseAllMedia and
     would stop the page's other silent autoplay videos). Tapping a slide still
     opens the fullscreen modal (with sound + controls), untouched. */

  function pauseAll() {
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
  }

  /* Pause only the OTHER videos inside THIS gallery -- never the global
     pauseAllMedia(), so silent looping proof-gallery / story-card videos
     elsewhere on the page keep playing while you browse the gallery. */
  function pauseGalleryVideosExcept(gallery, keepItem) {
    gallery.querySelectorAll('.product__media-item video').forEach(function (v) {
      if (keepItem && keepItem.contains && keepItem.contains(v)) return;
      if (!v.paused) { try { v.pause(); } catch (e) {} }
    });
  }

  function findDeferredMedia(scope) {
    if (!scope) return null;
    if (scope.matches && scope.matches('deferred-media, product-model')) return scope;
    return scope.querySelector('deferred-media, product-model');
  }

  function tuneVideo(video) {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.removeAttribute('controls');
  }

  /* Mount the inline <video> from Dawn's own deferred-media <template>, without
     going through loadContent() (which pauses all other media). Idempotent. */
  function mountInlineVideo(item) {
    var dm = item.querySelector('deferred-media');
    if (!dm) return;
    var existing = dm.querySelector('video');
    if (existing) { tuneVideo(existing); return; }
    var tmpl = dm.querySelector('template');
    var srcVideo = tmpl && tmpl.content ? tmpl.content.querySelector('video') : null;
    if (!srcVideo) return;
    var video = srcVideo.cloneNode(true);
    tuneVideo(video);
    video.setAttribute('preload', 'metadata');
    dm.setAttribute('loaded', 'true');
    dm.appendChild(video);
    var poster = dm.querySelector('.deferred-media__poster');
    if (poster) poster.style.display = 'none';
  }

  function mountInlineVideos(gallery) {
    gallery.querySelectorAll('.product__media-item').forEach(function (item) {
      if (item.querySelector('deferred-media')) mountInlineVideo(item);
    });
  }

  function ensurePlaying(media) {
    if (!media) return;
    var attempts = 0;
    (function tryPlay() {
      var video = media.querySelector ? media.querySelector('video') : null;
      if (video) {
        tuneVideo(video);
        if (video.paused) { var p = video.play(); if (p && typeof p.catch === 'function') p.catch(function () {}); }
        return;
      }
      if (typeof media.loadContent === 'function' && !media.getAttribute('loaded')) {
        try { media.loadContent(false); } catch (e) {}
      }
      if (attempts++ < 15) setTimeout(tryPlay, 60);
    })();
  }

  /* ---------------- Inline gallery (main viewer) ---------------- */

  function ensureExpandButton(activeItem, gallery) {
    var container = activeItem.querySelector('.product-media-container');
    if (!container) return;
    var btn = container.querySelector('.mr-gallery-expand');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mr-gallery-expand';
      btn.setAttribute('aria-label', 'Open full-screen view');
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M16 3h3a2 2 0 0 1 2 2v3"/><path d="M8 21H5a2 2 0 0 1-2-2v-3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>';
      container.appendChild(btn);
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var toggle = container.querySelector('.product__media-toggle');
        if (toggle) toggle.click();
      });
    }
    gallery.querySelectorAll('.mr-gallery-expand--visible').forEach(function (el) {
      if (el !== btn) el.classList.remove('mr-gallery-expand--visible');
    });
    btn.classList.add('mr-gallery-expand--visible');
  }

  function handleActiveChange(gallery) {
    var activeItem = gallery.querySelector('.product__media-item.is-active');
    if (!activeItem) return;
    var media = findDeferredMedia(activeItem);
    pauseGalleryVideosExcept(gallery, activeItem);
    ensurePlaying(media);
    ensureExpandButton(activeItem, gallery);
  }

  /* Play whichever media is actually the most-visible slide in the carousel,
     independent of Dawn's is-active class -- reinforces mobile swipe autoplay
     (harmless on desktop, where only one slide is visible). */
  function initVisibilityAutoplay(gallery) {
    if (!('IntersectionObserver' in window)) return;
    var list = gallery.querySelector('.product__media-list');
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      var best = null, bestRatio = 0;
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio > bestRatio) { best = e.target; bestRatio = e.intersectionRatio; }
      });
      if (best && bestRatio >= 0.55) {
        var media = findDeferredMedia(best);
        if (media) { pauseGalleryVideosExcept(gallery, best); ensurePlaying(media); }
      }
    }, { root: list || null, threshold: [0, 0.25, 0.55, 0.8, 1] });
    items.forEach(function (it) { io.observe(it); });
  }

  function initGallery(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;

    mountInlineVideos(gallery);
    handleActiveChange(gallery);
    initVisibilityAutoplay(gallery);

    var debounceId;
    viewer.addEventListener('slideChanged', function () {
      clearTimeout(debounceId);
      debounceId = setTimeout(function () {
        handleActiveChange(gallery);
      }, 120);
    });
  }

  /* ---------------- Full-screen viewer (product-modal) ---------------- */

  function modalMediaItems(modal) {
    var doc = modal.querySelector('[role="document"]');
    if (!doc) return [];
    return Array.from(doc.querySelectorAll('[data-media-id]'));
  }

  function activeModalIndex(items) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains('active')) return i;
    }
    return 0;
  }

  function setActiveModalMedia(modal, items, index) {
    if (!items.length) return;
    var next = ((index % items.length) + items.length) % items.length;
    pauseAll();
    items.forEach(function (el) { el.classList.remove('active'); });
    var target = items[next];
    target.classList.add('active');
    target.scrollIntoView();
    ensurePlaying(findDeferredMedia(target));
  }

  function stepModal(modal, delta) {
    var items = modalMediaItems(modal);
    var current = activeModalIndex(items);
    setActiveModalMedia(modal, items, current + delta);
  }

  function ensureModalNav(modal) {
    if (modal.querySelector('.product-media-modal__nav--prev')) return;
    var dialog = modal.querySelector('[role="dialog"]') || modal;

    function makeButton(direction, label, path) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-media-modal__nav product-media-modal__nav--' + direction;
      btn.setAttribute('aria-label', label);
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + path + '</svg>';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        stepModal(modal, direction === 'next' ? 1 : -1);
      });
      return btn;
    }

    dialog.appendChild(makeButton('prev', 'Previous media', '<path d="M15 18l-6-6 6-6"/>'));
    dialog.appendChild(makeButton('next', 'Next media', '<path d="M9 18l6-6-6-6"/>'));
  }

  function onModalOpened(modal) {
    ensureModalNav(modal);
    var items = modalMediaItems(modal);
    var active = items[activeModalIndex(items)];
    if (active) ensurePlaying(findDeferredMedia(active));
  }

  function watchModal(modal) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'open' && modal.hasAttribute('open')) {
          onModalOpened(modal);
        }
      });
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  document.addEventListener('keydown', function (event) {
    var modal = document.querySelector('product-modal[open]');
    if (!modal) return;
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      stepModal(modal, -1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      stepModal(modal, 1);
    }
  });

  function init(root) {
    root = root || document;
    root.querySelectorAll('media-gallery').forEach(initGallery);
    root.querySelectorAll('product-modal').forEach(watchModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.MRProductGallery = { init: init };
})();
